import { useContext } from "react";
import {
  DeleteAccountDialogContext,
  DeleteAccountDialogContextType,
} from "./DeleteAccountDialogContext";

export const useDeleteAccountDialog = (): DeleteAccountDialogContextType => {
  const context = useContext(DeleteAccountDialogContext);
  if (!context) {
    throw new Error(
      "useDeleteAccountDialog must be used within a DeleteAccountDialogProvider"
    );
  }
  return context;
};
